import { defineStore } from 'pinia'

import type { CustomerCommentsStore } from './interfaces'

import { actions } from './actions'
import { getters } from './getters'

export const useCustomerCommentsStore = defineStore('customer-comments', {
  state: (): CustomerCommentsStore => ({
    loading: false,
    loadingMore: false,
    comments: [],
    nextCursor: null,
    filterDisciplines: [],
    perPage: 25,
  }),
  actions,
  getters,
})
